const getDefaultState = () => {
    return {
        rates: [],
        rate: {},
        totalItems: null,
        totalPage: null
    }
  }
  
  const state = getDefaultState();
  
  export { state, getDefaultState };